import { createSelector } from 'reselect';

const infiniteScrollSelector = state => state.infiniteScroll;
const adsSelector = state => state.ads;
const uiSelector = state => state.ui;

export default createSelector(
	[ infiniteScrollSelector, adsSelector, uiSelector ],
	( infiniteScroll, ads, ui ) => {
		return {
			...infiniteScroll,
			adSlots: ads.adSlots,
			iOSkeyBoardOpen: ui.iOSkeyBoardOpen,
			announcementsOpen: ui.announcementsOpen,
			shareModalOpened: ui.shareModal.opened,
			headerOverflowOpened: ui.headerOverflowOpened,
			sidebarOpened: ui.sidebarOpened,
			searchBarOpened: ui.searchBarOpened,
			userModalOpened: ui.userModal.opened
		};
	}
);



// WEBPACK FOOTER //
// ./src/selectors/infiniteScrollSelector.js